import React from 'react'
import DisplayUpdateTime from 'ui/DisplayUpdateTime'
import { DataTableRowActions } from './data-table-row-action'
import {
  columnCover,
  columnName,
  columnState,
} from 'components/template-data-table-column'

export const columns = [
  {
    header: '#',
    cell: ({ row }) => row.index + 1,
  },
  columnCover,
  columnName,
  columnState,
  {
    header: 'Publish Time',
    accessorKey: 'publishTime',
    cell: ({ row }) => (
      <DisplayUpdateTime updateTime={row.original.publishTime} />
    ),
  },
  {
    header: 'Actions',
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
]
